import axios from "../api";

export const updateIsOpenedTourGuideUserAPI = (id, payload) => {
  return axios.put(`/users/${id}`, payload);
};
